// extracted by mini-css-extract-plugin
export default {"component":"tPLw-","popover":"-RdQ1"};